import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { activeStepDescriptionSelector, isQRActiveStep, activeStepSelector } from '../selectors/wizardSelectors';
import StepDescription from '../components/StepDescription/StepDescription';

const mapStateToProps = createStructuredSelector({
    activeStep: activeStepSelector,
    activeStepDescription: activeStepDescriptionSelector,
    isQRActiveStep: isQRActiveStep
});

export default withTranslation(['common', 'wizard'])(
    connect(mapStateToProps, null)(StepDescription)
);
